import { forwardRef, type Ref, type SVGProps } from "react";
const IconHearingAidFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20.47 2.05a1.07 1.07 0 1 0-.652 2.041c4.521 1.437 7.019 6.256 5.579 10.765a1.074 1.074 0 0 0 2.047.65c1.8-5.636-1.323-11.66-6.974-13.455" />
    <path
      fillRule="evenodd"
      d="M13.498 4.082h-.644c-5.012.35-8.807 4.623-8.807 9.597v9.596c0 3.293 2.435 6.235 5.728 6.655.287.07.573.07.86.07 3.65 0 6.658-2.872 6.658-6.445v-.63c-.072-.56.215-1.12.716-1.401 2.935-1.541 4.94-4.623 4.94-8.126 0-5.183-4.224-9.316-9.45-9.316M8.133 24.977c-.238 0-.555-.078-.714-.312-.397-.389-.397-1.09 0-1.479.476-.467 1.825-2.024 1.825-3.425 0-.622-.317-1.245-.714-1.946-.635-1.012-1.35-2.257-1.35-4.28 0-3.504 2.7-6.15 6.271-6.15 3.492 0 6.27 2.802 6.27 6.15 0 .855-.158 1.712-.555 2.49-.238.545-.873.778-1.35.545-.555-.234-.793-.856-.555-1.323.238-.545.317-1.09.317-1.635 0-2.257-1.904-4.126-4.206-4.126-2.46 0-4.207 1.713-4.207 4.126 0 1.342.51 2.255.971 3.083l.06.108.135.24c.44.779.898 1.588.898 2.718 0 2.413-2.143 4.593-2.381 4.826a.95.95 0 0 1-.715.39"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHearingAidFilledSVG);
ForwardRef.displayName = "IconHearingAidFilled";
export { ForwardRef as IconHearingAidFilled };
